import basicController from "servicestack/basic.controller.properties";
import TEMPLATE_URL from "emun.products/lists/apply-tags-prompt.htm";
import controller from "emun.products/lists/apply-tags-prompt.controller";
import open from "webmodals/open";

const NOOP = () => {};

export default ({
  size = "md",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  request: {} = {},
  tags = [],
  productIds = [],
  title = `Apply Product Tags...`,
} = {}) =>
  open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        title,
        request: {
          productIds,
        }
      })
    }
  }).result;
